import { Table } from "@mantine/core"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import classes from "./empty-lines.module.css"

type Props = {
  /** Column titles of the lines table, so the empty card already shows its grey header row. */
  columns: ReactNode[]
  /** Overrides the default «Та бараа оруулна уу.» line. */
  message?: ReactNode
}

/** Empty order-line table of OrdB_SupplierOrder: the grey header row and one centred text row. */
export function EmptyLines({ columns, message }: Props) {
  const { t } = useTranslation("supplierSales")
  return (
    <Table className={classes.table} horizontalSpacing="md" verticalSpacing="sm">
      <Table.Thead>
        <Table.Tr>
          {columns.map((title, i) => (
            <Table.Th key={i} className={classes.th}>{title}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <Table.Td colSpan={Math.max(columns.length, 1)} className={classes.emptyCell}>
            {message ?? t("sales.pleaseAddProducts")}
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    </Table>
  )
}
